import Route from '@ember/routing/route'
import { task, timeout } from 'ember-concurrency'
import { service } from '@ember/service'
import type ContentfulClient from 'teacher-ui-client/services/contentful-client'
import type { Params as LessonsParams } from 'teacher-ui-client/subscription-type/lessons/route'
import { deserializeThreads } from 'teacher-ui-client/components/lessons/mathseeds-prime/thread-filter'
import type { MathseedsPrimeThread } from 'teacher-ui-client/progression-sequence/utils'
import type MathseedsPrime from 'teacher-ui-client/services/mathseeds-prime'

interface Params extends Record<string, unknown> {
  filterThread?: string
}

export default class MathseedsPrimeLessonsRoute extends Route {
  @service contentfulClient!: ContentfulClient

  @service mathseedsPrime!: MathseedsPrime

  queryParams = {
    filterThread: {
      replace: true,
      refreshModel: true,
    },
  }

  model({ filterThread: serializedThreads }: Params) {
    const lessonsParams = this.paramsFor('subscription-type.lessons') as LessonsParams
    const { perPage, pageNumber, searchQuery } = lessonsParams
    const threads = typeof serializedThreads === 'string' ? deserializeThreads(serializedThreads) : []

    return {
      loaderInstance: this.fetchEntries.perform({ pageNumber, perPage, searchQuery, threads }),
    }
  }

  fetchEntries = task(
    { restartable: true },
    async ({
      pageNumber,
      perPage,
      searchQuery,
      threads,
    }: {
      pageNumber: number
      perPage: number
      searchQuery?: string
      threads: MathseedsPrimeThread[]
    }) => {
      await timeout(500)
      const gradeIds = this.mathseedsPrime.supportedGradeIds
      const lessons = await this.contentfulClient.getMathseedsPrimeLessons({
        pageNumber,
        perPage,
        searchQuery,
        threads,
        gradeIds,
      })

      const pageCount = Math.ceil(lessons.total / perPage)

      return { lessons, pageCount }
    },
  )
}
